import { StateParams, StateService } from "@uirouter/angularjs";
import {CmdCenterEditSiteModel} from "../../models/cmd/CmdCenterEditSiteModel";
import {NotificationService} from "../../services/NotificationService";

export class CmdCenterEditSiteCtrl {
    public static $inject = ['$scope', '$state', '$stateParams', '$uibModal', 'CmdCenterEditSiteModel','NotificationService'];
    constructor(public $scope:any,
                public stateService:StateService,
                public stateParamsService:StateParams,
                public modal:angular.ui.bootstrap.IModalService,
                public model:CmdCenterEditSiteModel,
                public notifyService:NotificationService) {
        $scope.vm = this;
        var id = stateParamsService["id"];
        //alert("edit site: "+id);
        this.model.init(id);
    }
    save(){
        this.model.save().then(ok=>{
            if(ok)
                this.stateService.go("cmdcenter.sitearea",{"mapSiteId":this.model.mapSite.id});
        }).catch((exc)=>{
          this.notifyService.notifyError("Error in saving Site:"+exc);
        });
    }
    cancel(){
        this.stateService.go("cmdcenter.sitearea",{"mapSiteId":this.model.mapSite.id});
    }
}
